import React from "react";
import Image from "next/image";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import styles from "./ServiceEvents.module.css";
import { ButtonGroupProps, ArrowProps } from "react-multi-carousel/lib/types";

interface CustomLeftArrowProps extends ArrowProps {
  className?: string;
}
interface CustomRightArrowProps extends ArrowProps {
  className?: string;
}
interface CarouselButtonGroupProps extends ButtonGroupProps {
  className?: string;
  next?: () => void;
  previous?: () => void;
}
interface serviceEventsProps {
  serviceEvents: {
    nodes: {
      name: string;
      categoryOptions: {
        categoryImage: {
          sourceUrl: string;
          altText: string;
          mediaDetails: {
            height: number;
            width: number;
          };
        };
      };
    }[];
  };
}

const ServiceEvents = ({ serviceEvents }: serviceEventsProps) => {
  const hasEvents = serviceEvents.nodes.length > 0;
  const carouselResponsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1600 },
      items: 5,
      slidesToSlide: 5,
    },
    desktop: {
      breakpoint: { max: 1600, min: 1024 },
      items: 4,
      slidesToSlide: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 3,
      slidesToSlide: 3,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
      slidesToSlide: 2,
    },
  };

  const CustomLeftArrow = ({ className, onClick }: CustomLeftArrowProps) => {
    return (
      <button className={className} onClick={onClick}>
        <Image src="/right-arrow.svg" width={22} height={22} alt="Read More" />
      </button>
    );
  };
  const CustomRightArrow = ({ className, onClick }: CustomRightArrowProps) => {
    return (
      <button className={className} onClick={onClick}>
        <Image src="/right-arrow.svg" width={22} height={22} alt="Read More" />
      </button>
    );
  };

  const ButtonGroup = ({
    next,
    previous,
    carouselState,
  }: CarouselButtonGroupProps) => {
    const { currentSlide } = carouselState ?? {};
    const lastPage = serviceEvents.nodes.length - 5;
    return (
      <div className="carousel-button-group">
        <CustomLeftArrow
          className={`absolute left-0 top-1/2 -translate-y-1/2 ml-5 lg:ml-10 transition-all duration-300 ease-in-out rotate-180`}
          onClick={() => previous?.()}
        />
        <CustomRightArrow
          className={`absolute right-0 top-1/2 -translate-y-1/2 mr-5 lg:mr-10 transition-all duration-300 ease-in-out`}
          onClick={() => next?.()}
        />
      </div>
    );
  };

  if (!hasEvents) return null;

  return (
    <section>
      <div className="relative mx-auto mb-10 max-w-[1500px] px-5 lg:px-20 pb-10 md:pb-20">
        <div className="relative flex items-center">
          <h2
            className={`my-10 flex flex-row text-left font-serif font-bold tracking-wider`}
          >
            <span className="font-serif text-[1.35rem] font-semibold">
              EVENTS
            </span>{" "}
            <span
              className={`ml-2 font-serif text-[1.35rem] font-normal italic`}
            >
              elevated
            </span>
          </h2>
          <div className="ml-10 h-[1px] w-full bg-black"></div>
        </div>
        <div className={styles.carousel}>
          <Carousel
            responsive={carouselResponsive}
            showDots={true}
            draggable={false}
            // swipeable={false}
            renderDotsOutside={true}
            arrows={false}
            customButtonGroup={<ButtonGroup />}
            renderButtonGroupOutside={true}
          >
            {serviceEvents.nodes.map((event, index) => {
              const image = event.categoryOptions.categoryImage;
              const { sourceUrl, altText, mediaDetails } = image;
              return (
                <div
                  key={index}
                  className={`flex flex-col items-center justify-center`}
                >
                  <div
                    className={`relative overflow-hidden rounded-full w-[100px] h-[100px] md:min-w-[200px] md:min-h-[200px]`}
                  >
                    <Image
                      src={sourceUrl ?? ""}
                      alt={altText ?? ""}
                      fill
                      className={`h-full w-full object-cover`}
                    />
                  </div>
                  <h3
                    className={`text-[.75rem] md:text-[.9rem] mx-auto mt-5 max-w-[12rem] text-center font-bold uppercase`}
                  >
                    {event?.name}
                  </h3>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default ServiceEvents;
